module.exports = __webpack_public_path__ + "img/控制器.60bad35e.png";